import { useGetUsersPreferencesWaterCharacteristics } from "@imi/api-client/index.js";
import { useTranslation } from "react-i18next";
import { useQueryState } from "./queries/useQueryState";

export function useWaterCharacteristicsPreference() {
  const { t } = useTranslation("settings", {
    keyPrefix: "technicalPreferences.waterCharacteristics",
  });
  return useQueryState(
    useGetUsersPreferencesWaterCharacteristics(),
    t("errors.fetchUnknown"),
  );
}
